import { App } from '@scaleaq/scaleui';
import { createLink } from '@tanstack/react-router';
import styled from 'styled-components';

import { colors } from '@/utils';

export const AppSideBarItemLink = createLink(App.SideBar.Item);

/** Scale UI leaves the main nav section transparent; take the footer's tint so both read as one surface. */
export const SideBarMain = styled(App.SideBar.Main)`
  background-color: ${colors.background.action.soft['50']};
`;

const TopBarLogoAnchor = styled.a`
  display: flex;
  align-items: center;
  color: inherit;
  text-decoration: none;
`;

/** The product logo doubles as the dashboard link, so it carries no link chrome. */
export const TopBarLogoLink = createLink(TopBarLogoAnchor);

const BreadCrumbAnchor = styled.a`
  max-width: 100%;
  overflow: hidden;
  color: inherit;
  font: inherit;
  text-overflow: ellipsis;
  text-decoration: underline;
  white-space: nowrap;
`;

/** Navigable crumb, styled like the site-selector trigger so both read the same in the top bar. */
export const BreadCrumbLink = createLink(BreadCrumbAnchor);

/** Marks trailing content in `App.SideBar.Item` children so the hover-only slot stays visible. */
const SIDEBAR_ITEM_TRAILING_ATTR = 'data-sidebar-trailing';
export const sidebarItemTrailingProps = { [SIDEBAR_ITEM_TRAILING_ATTR]: '' } as const;

/**
 * Scale UI's item children slot is `opacity: 0` until hover. Force it visible when it contains
 * marked trailing content (site-selector chevron, service warning).
 */
export const SidebarItemVisibleTrailing = styled.div`
  display: contents;

  a + div:has([${SIDEBAR_ITEM_TRAILING_ATTR}]) {
    opacity: 1;
    transform: scale(1);
  }
`;
